import { render, staticRenderFns } from "./FollowUpSequenceStepTemplateForm.vue?vue&type=template&id=54839bca&scoped=true&"
import script from "./FollowUpSequenceStepTemplateForm.vue?vue&type=script&lang=js&"
export * from "./FollowUpSequenceStepTemplateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54839bca",
  null
  
)

export default component.exports